import "@Styles/Shared/RecipeParts/StepShots/recipeStepShots_sm.less";
import "@Styles/Shared/RecipeParts/StepShots/PB/recipeStepShots_sm.less";
import "@Styles/Shared/RecipeParts/StepShots/recipeStepShots_md.less";
import "@Styles/Shared/RecipeParts/StepShots/PB/recipeStepShots_md.less";
import { LazyLoadImages } from '@Shared/Common';
export default {
  data: function data() {
    return {
      config: {},
      areImagesHidden: false,
      toggleImagesClass: "",
      toggleButtonText: "Hide Images",
      hideButtonText: "Hide Images",
      showButtonText: "Show Images"
    };
  },
  directives: {
    lazyloadimages: LazyLoadImages
  },
  methods: {
    init: function init(config) {
      if (config) {
        this.config = config;
        this.areImagesHidden = !!this.config.initAreImagesHidden;
        if (this.config.hideImagesButtonText) this.hideButtonText = this.config.hideImagesButtonText;
        if (this.config.showImagesButtonText) this.showButtonText = this.config.showImagesButtonText;
      }

      this.$_toggle();
    },
    toggleImages: function toggleImages() {
      this.areImagesHidden = !this.areImagesHidden;
      this.$_toggle();
      var eventName = this.areImagesHidden ? this.config.hideImagesEventName : this.config.showImagesEventName;
      if (eventName && GeneralMills.Analytics) GeneralMills.Analytics.raiseEvent({
        EventType: eventName
      });
      this.$refs.recipeSteps.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    },
    $_toggle: function $_toggle() {
      this.toggleImagesClass = this.areImagesHidden ? this.config.hideImagesClass : '';
      this.toggleButtonText = this.areImagesHidden ? this.showButtonText : this.hideButtonText;
    }
  }
};